import moment from 'moment';
import { createContext, useContext, useState } from 'react';
import 'moment/locale/uk';

const BookingContext = createContext();

const initState = {
  selectedDate: moment(),
  endTime: null,
  startTime: null,
  price: 0,
  court: null,
  isPhoneModalOpen: false
};

export const BookingProvider = ({ children }) => {
  const [state, setState] = useState(initState);

  const clearState = () => {
    setState(initState);
  };

  const setIsOpenModal = (isPhoneModalOpen) => {
    setState((prevState) => ({ ...prevState, isPhoneModalOpen }));
  };

  const setPrice = (price) => {
    setState((prevState) => {
      if (prevState.price === price) {
        return prevState;
      }

      return { ...prevState, price };
    });
  };
  const setCourt = (court) => {
    setState((prevState) => ({ ...prevState, court }));
  };

  const setSelectedDate = (selectedDate) => {
    setState(() => ({ ...initState, selectedDate }));
  };
  const setTime = (time) => {
    if (state.startTime && !state.endTime) {
      setState((prevState) => ({ ...prevState, endTime: time }));
    } else if (!state.startTime) {
      setState((prevState) => ({ ...prevState, startTime: time }));
    } else if (state.startTime && state.endTime) {
      setState((prevState) => ({ ...prevState, startTime: time, endTime: null }));
    }
  };
  const resetTime = () => {
    setState((prevState) => ({ ...prevState, startTime: null, endTime: null }));
  };

  const data = {
    ...state,
    setCourt,
    setPrice,
    setSelectedDate,
    setTime,
    resetTime,
    setIsOpenModal,
    clearState
  };
  return <BookingContext.Provider value={data}>{children}</BookingContext.Provider>;
};

export const useBookingContext = () => {
  const context = useContext(BookingContext);
  if (context === undefined) {
    throw new Error('useBookingContext must be used within a BookingProvider');
  }
  return context;
};
